import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BottomSheet } from '../../../../../app/common/sharedComponents/BottomSheet';
import DatePicker from '../../../Datepicker';
import { DateFormatEnum, formatDate } from '../../../../../helpers/dates';
import { DatePickerContainer } from './styled';

interface IAssessment {
  stayStart: string;
  id: number;
  score?: number;
  templateId?: number;
}

interface IAssessmentDatePickerProps {
  isOpen: boolean;
  onClose: () => void;
  assessments: IAssessment[];
  selectedAssessment?: string;
  isSelectDate?: boolean;
  onDateSelect: (dateSelection: { value: string }) => void;
}

function AssessmentDatePicker ({
  isOpen,
  onClose,
  assessments,
  selectedAssessment,
  isSelectDate,
  onDateSelect,
}: IAssessmentDatePickerProps) {
  const { t } = useTranslation();

  const sortedAssessments = useMemo(() => {
    const assessmentData = isSelectDate
      ? assessments.find((assessment) => assessment.stayStart === selectedAssessment)
      : assessments.find((assessment) => assessment.id.toString() === selectedAssessment);

    const selectedAssessmentStartDate =
      (assessmentData && assessmentData.stayStart) || '';

    const nextAssessments = assessments.filter(
      (assessment) => assessment.stayStart <= selectedAssessmentStartDate
    );
    const previousAssessments = assessments.filter(
      (assessment) => assessment.stayStart > selectedAssessmentStartDate
    );

    return [...nextAssessments, ...previousAssessments];
  }, [assessments, selectedAssessment, isSelectDate]);

  if (!sortedAssessments.length || !isOpen) {
    return null;
  }

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
    >
      <DatePickerContainer>
        <DatePicker
          isHotelSelector={false}
          source={sortedAssessments.map((assessment) => ({
            columns: [formatDate(assessment.stayStart, DateFormatEnum.charDate)],
            value: assessment.stayStart,
          }))}
          handleSelectedDate={onDateSelect}
        />
      </DatePickerContainer>
    </BottomSheet>
  );
}

export { AssessmentDatePicker };
